import { ClearOutlined, DeleteOutlined, EyeInvisibleOutlined, EyeOutlined, UploadOutlined } from '@ant-design/icons';
import { BlobProvider } from '@react-pdf/renderer';
import { Button, Col, Modal, Row, Upload, message } from 'antd';
import { useEffect, useState } from 'react';
import { useFormContext } from '../../Context/DeclarationContext';
import { getUrlFileBase64, uploadFiles } from '../../Services/declarations';
import RutTools from '../../helpers/format-rut';
import { FILE_UPLOAD_GENERAL_ERROR, FILE_UPLOAD_LARGE_ERROR } from '../../utils/generals';
import SignatureDeclarations from '../Pdf/signature_declaration';
import SignatureForm from '../Signature_component';
import './index.scss';

interface IAdjunto {
  obligatorio: boolean;
  nombre: string;
  nombreAdjunto?: string;
  adjuntar: boolean;
  visualizar: boolean;
  componentFirma?: string;
  documentType: string;
  deleteItemIndexDOCA: (index: string) => void;
}

const contentTypeMap = {
  pdf: 'application/pdf',
  png: 'image/png',
  jpg: 'image/jpg',
  jpeg: 'image/jpeg',
  jfif: 'image/jpeg',
  gif: 'image/gif',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  txt: 'text/plain',
  csv: 'text/csv',
  xml: 'application/xml',
  json: 'application/json',
  zip: 'application/zip',
  rar: 'application/x-rar-compressed',
  '7z': 'application/x-7z-compressed',
  tar: 'application/x-tar',
  gz: 'application/gzip',
  bz2: 'application/x-bzip2',
  mp3: 'audio/mpeg',
  wav: 'audio/wav',
  ogg: 'audio/ogg',
  mp4: 'video/mp4',
  mov: 'video/quicktime',
  avi: 'video/x-msvideo',
  wmv: 'video/x-ms-wmv',
  flv: 'video/x-flv',
  mpeg: 'video/mpeg',
  webm: 'video/webm',
  webp: 'image/webp',
  svg: 'image/svg+xml',
  html: 'text/html',
  css: 'text/css',
  js: 'application/javascript',
  php: 'application/x-httpd-php',
};

const FormAdjunto = ({
  obligatorio,
  nombre,
  nombreAdjunto,
  adjuntar,
  visualizar,
  componentFirma = '',
  documentType,
  deleteItemIndexDOCA,
}: IAdjunto) => {
  const [openModal, setOpenModal] = useState(false);
  const [saveDocumentFDF, setSaveDocumentFDF] = useState(false);
  const [urlFile, setUrlFile] = useState('');

  // const [isOpenAttachmentModal, setIsOpenAttachmentModal] = useState<boolean>(false);
  const { state, dispatch } = useFormContext();
  const extencion = nombreAdjunto?.split('.').pop() || '';
  const [extencionFDF, setExtencionFDF] = useState<any>(null);
  const [uploadDisabled, setUploadDisabled] = useState<boolean>(false);

  const getUrlFetch = async (filename: string) => {
    const response = await getUrlFileBase64(filename);
    setUrlFile(response.data.buffer);
  };

  useEffect(() => {
    if (nombreAdjunto) {
      getUrlFetch(nombreAdjunto || 'nombreAdjunto');
    }
  }, []);

  useEffect(() => {
    const document = state.state_document?.find((doc) => doc.documentType === documentType);
    if (document?.filename) {
      setUploadDisabled(true);
      getUrlFetch(document.filename || '');
    }
  }, [uploadDisabled]);

  const fdfDocManage = () => {
    const document = state.state_document || [];
    const filename = `${state.vehiclePatente?.deviceId}_${RutTools.formatWithoutDots(state.declarant?.customerIdentityNumber as string)}_FDF.pdf`;
    const index = document.findIndex((doc) => doc.documentType === 'FDF');

    if (index !== -1) {
      document[index].filename = filename;
    }
  };

  useEffect(() => {
    if (saveDocumentFDF) {
      setExtencionFDF('fdf');
      const document = state.state_document?.find((doc) => doc.documentType === documentType);
      if (document?.documentType === 'FDF') fdfDocManage();
      if (document?.filename) {
        console.log('state.state_document ✅✅', state.state_document);
        setUploadDisabled(true);
        getUrlFetch(document.filename || '');
      }
    }
  }, [saveDocumentFDF]);

  return (
    <>
      <Row gutter={[16, 16]} justify={'center'} className="classRowAdjunto">
        <Col span={8}>
          <label>{obligatorio ? <span className="text_obligatorio">Obligatorio</span> : <span className="text_obligatorio">Opcional</span>}</label>
        </Col>
        <Col span={8}>
          <label data-render={documentType}>
            {nombre}
            {componentFirma === 'CROB' && (
              <small>
                <a href="/cuestionario_robo.pdf" download="cuestionario_robo.pdf" className="crob_link">
                  {' '}
                  Descargar cuestionario
                </a>
              </small>
            )}
            {componentFirma === 'FDF' && (
              <small>
                <BlobProvider document={<SignatureDeclarations state={state} />}>
                  {({ blob, url, loading, error }) => {
                    return (
                      <a href={url as string} download="FDF.pdf" className="crob_link">
                        {' '}
                        Descargar declaración
                      </a>
                    );
                  }}
                </BlobProvider>
              </small>
            )}
          </label>
        </Col>
        {true ? (
          <Col span={3}>
            <Upload
              disabled={uploadDisabled}
              name="avatar"
              showUploadList={false}
              maxCount={6}
              customRequest={() => {}}
              onChange={async (info) => {
                console.log('File info', info);
                try {
                  if (info.file !== undefined) {
                    info.file.name = `${state.vehiclePatente?.deviceId}_${RutTools.formatWithoutDots(state?.declarant?.customerIdentityNumber || ('' as string))}`;

                    const response = await uploadFiles(
                      info.file.originFileObj,
                      documentType,
                      `${state.vehiclePatente?.deviceId}_${RutTools.formatWithoutDots(state.declarant?.customerIdentityNumber || ('' as string))}`
                    );

                    let document = state?.state_document || [];
                    info.file.status = 'done';
                    // buscar en document si existe el documento con el mismo tipo, si existe solo cambiar el nombre del archivo y la url
                    const index = document.findIndex((doc) => doc.documentType === documentType);
                    if (index !== -1) {
                      document[index].filename = response.data[0].filename;
                      document[index].url = response.data[0].url;
                      document[index].status = 'done';
                      document[index].isActive = true;
                    }

                    dispatch({
                      type: 'UPDATE_STATE_DOCUMENT',
                      payload: [...document],
                    });
                    message.success('Documento subido correctamente');
                    setUploadDisabled(true);
                  }
                } catch (error) {
                  const g = error as any;
                  if (g?.status === 413) {
                    message.error(FILE_UPLOAD_LARGE_ERROR);
                  } else {
                    message.error(FILE_UPLOAD_GENERAL_ERROR);
                  }
                }
              }}
            >
              <div className="upload_file_row">
                <UploadOutlined className={uploadDisabled ? 'upload_disabled' : ''} />
              </div>
            </Upload>
            {/* )} */}
          </Col>
        ) : (
          <Col span={3}></Col>
        )}

        <Col span={3}>
          {urlFile ? (
            <Button
              type="text"
              className="btn_add"
              onClick={() => {
                // urlFile is un strimg base64 necesary to convert to blob to open in new tab
                const byteCharacters = atob(urlFile);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: contentTypeMap[(extencion ? extencion : 'pdf') as keyof typeof contentTypeMap] });
                const blobUrl = URL.createObjectURL(blob);

                window.open(blobUrl);
              }}
            >
              {' '}
              <EyeOutlined />{' '}
            </Button>
          ) : (
            <a className={urlFile ? 'btn_add' : 'btn_add_disbled'}>
              {' '}
              <EyeInvisibleOutlined />{' '}
            </a>
          )}
        </Col>
        <Col span={2}>
          {obligatorio ? (
            <Button className="btn_add" type="text" disabled={urlFile ? false : true}>
              <ClearOutlined
                className={urlFile ? 'btn_add' : 'btn_add_disbled'}
                onClick={() => {
                  setUploadDisabled(false);
                  const document = state?.state_document || [];
                  const index = document.findIndex((doc) => doc.documentType === documentType);
                  if (index !== -1) {
                    if (obligatorio) {
                      document[index].filename = '';
                      document[index].url = '';
                      document[index].status = 'done';
                    } else {
                      document[index].filename = '';
                      document[index].url = '';
                      document[index].status = 'done';
                      document[index].isActive = false;
                    }
                  }
                  dispatch({
                    type: 'UPDATE_STATE_DOCUMENT',
                    payload: [...document],
                  });
                  setUrlFile('');
                  setSaveDocumentFDF(false);
                  message.success('Documento eliminado correctamente');
                }}
              />
            </Button>
          ) : (
            // <Button className="btn_add" type="text" disabled={urlFile ? false : true}>
            <Button className="btn_add" type="text" disabled={false}>
              <DeleteOutlined className={urlFile ? 'btn_add' : 'btn_add_disbled'} onClick={() => deleteItemIndexDOCA(documentType)} />
            </Button>
          )}
        </Col>
      </Row>

      <Modal
        title="Formulario de declaracion firmada"
        open={openModal}
        footer={null}
        onCancel={() => {
          setOpenModal(!openModal);
        }}
        width={'100%'}
        centered
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <SignatureForm
            openModal={openModal}
            setOpenModal={setOpenModal}
            saveDocumentFDF={saveDocumentFDF}
            setSaveDocumentFDF={setSaveDocumentFDF}
          />
        </div>
      </Modal>

      {/* <AttachmentModal isOpen={isOpenAttachmentModal} handleClose={() => setIsOpenAttachmentModal(false)} /> */}
    </>
  );
};

export default FormAdjunto;
